import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Input from '../input'
import emitOnBlur from '@cred/react-analytics/hoc/emitOnBlur'
import emitOnKeyPress from '@cred/react-analytics/hoc/emitOnKeyPress'
import {FormField} from '@cred/react-form-field'
import NumberFormat from 'react-number-format'
import {Label} from '@cred/react-label'
import {moneyInputWarning} from '@cred/shared/validations'
import styles from './styles.module.scss'

/**
 * @deprecated MoneyInput is deprecated, please use @cred/react-basic-form-fields/Money or @cred/react-basic-form-fields/[reduxForm|hookForm]/Money instead.
 * @visibleName Money Input
 */
class MoneyInput extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    warningType: PropTypes.string,
    maskedField: PropTypes.bool,
    disabledField: PropTypes.bool
  }

  static defaultProps = {
    label: '',
    maskedField: false,
    disabledField: false,
    maxAllowedValue: 9999999,
  }

  static displayName = 'MoneyInput'

  render() {
    const {className, name, label, validate, placeholder, ...props} = this.props

    return (
      <div className={className}>
        <Input
          type="text"
          name={`${name}`}
          component={inputWithAnalytics}
          validate={validate}
          placeholder={placeholder}
          inputStyles={styles}
          label={label}
          {...props}/>
      </div>
    )
  }
}

const inputComponent = ({input, label, meta, id, getInputRef, decimalScale = 0, theme, placeholder = '$', icon = true, inputStyles, warningType, maskedField, disabledField, type = 'tel', inputMode, maxAllowedValue }) =>
    <FormField status={meta} error={meta.error} value={input.value} label={label} icon={icon} theme={theme} warning={moneyInputWarning(input.value, warningType)} maskedField={maskedField} disabledField={disabledField}>
      <div className={inputStyles.inputContainer}>
        <div className={inputStyles.dollarSign}><i className="cred-icon icon-money-dollar"></i></div>
        <div className={inputStyles.input}>
          <NumberFormat
            isAllowed={({floatValue}) => floatValue === undefined || floatValue <= maxAllowedValue}
            thousandSeparator={true}
            prefix="$"
            decimalScale={decimalScale}
            allowNegative={false}
            type={type}
            placeholder={placeholder}
            maxLength="13"
            id={id || input.name}
            getInputRef={getInputRef}
            disabled={disabledField}
            inputMode={inputMode}
            {...input}
          />
        </div>
        <Label className={inputStyles.label} htmlFor={id || input.name}>{label}</Label>
      </div>
    </FormField>,
  inputWithAnalytics = /*#__PURE__*/ emitOnKeyPress(emitOnBlur(inputComponent))

export {MoneyInput as MoneyInputNoHoc, inputComponent}

export default /*#__PURE__*/ MoneyInput
